import Link from "next/link";
import { useTranslation } from "next-i18next";

import { Card } from "common/ui/Card";
import { Heading } from "common/ui/Heading";
import { BodyFrame } from "common/ui/BodyFrame";

import { ROUTES } from "constants/routes";

import styles from "./HomeView.module.scss";

export function HomeView() {
  const { t } = useTranslation("host");

  return (
    <BodyFrame className={styles.HomeView}>
      <Link href={ROUTES.LISTINGS.BASE}>
        <Card className={styles.Card}>
          <Heading variant="h1">
            {t("common.listings")}
          </Heading>
        </Card>
      </Link>
      <Link href={ROUTES.USERS.BASE}>
        <Card className={styles.Card}>
          <Heading variant="h1">
            {t("common.users", "Users")}
          </Heading>
        </Card>
      </Link>
      <Link href={ROUTES.QR_CODES.BASE}>
        <Card className={styles.Card}>
          <Heading variant="h1">
            {t("common.qrCodes", "QR Codes")}
          </Heading>
        </Card>
      </Link>
      {/* TODO Waiting for UX */}
      {/* <Link href="/subscriptions">
        <Card className={styles.Card}>
          <Heading variant="h1">
            {t("common.subscriptions")}
          </Heading>
        </Card>
      </Link> */}
      <Link href={ROUTES.SEED_DATA.BASE}>
        <Card className={styles.Card}>
          <Heading variant="h1">
            {t("seedData.title", "Generate Seed Data")}
          </Heading>
        </Card>
      </Link>
    </BodyFrame>
  )
}
